export type SalesDataSourceSaveRejectionReasonPayload = {
  id?: number
  rejectionReason: string
}
